import styled, {keyframes} from "styled-components";
import {useAtom} from "jotai";
import {modalController} from "../../store";
import {useCallback, useEffect} from "react";

function Modal(props) {
  const [modalComponent] = useAtom(modalController)

  return (
    <>
      {props.isShow &&
        <Dim id={'modal'} $blur={modalComponent.blur}>
          <ModalContainer style={{width: modalComponent.width? modalComponent.width: 500}}>
            {modalComponent.modalComponent()}
          </ModalContainer>
        </Dim>
      }
    </>
  )
}

export function ModalHeader (props) {
  const [,setModal] = useAtom(modalController)
  const modalClose = useCallback(() => {
    setModal({
      isShow: false,
      modalComponent: null,
    });
  }, [setModal]);

  useEffect(() => {
    const escKeyModalClose = (e) => {
      if (e.key === 'Escape') {
        modalClose();
      }
    };

    window.addEventListener('keydown', escKeyModalClose);

    return () => {
      window.removeEventListener('keydown', escKeyModalClose);
    };
  }, [modalClose]);

  return(
    <ModalHeaderContainer $variant={props.variant}>
      <LabelInline>
        <span>{props.title}</span>
        {props.closeBtn !== false && <Close onClick={modalClose}/>}
      </LabelInline>
    </ModalHeaderContainer>
  )
}

export function ModalBody (props) {

  return(
    <ModalBodyContainer>
      {props.children}
    </ModalBodyContainer>
  )
}

export function ModalFooter(props) {
  return(
    <ModalFooterContainer style={props.style}>
      {props.children}
    </ModalFooterContainer>
  )
}
export default Modal

const ModalBodyContainer = styled.main`
  padding: 20px 25px;
`
const Dim = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  background-color: ${({$blur}) => ($blur ? "rgba(15, 23, 42, .46)" : "rgba(0,0,0,.5)")};
  backdrop-filter: ${({$blur}) => ($blur ? "blur(5px)" : "none")};
  -webkit-backdrop-filter: ${({$blur}) => ($blur ? "blur(5px)" : "none")};
  z-index: 1000;
`
const fadeIn = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`

export const ModalContainer = styled.div`
  max-width: calc(100vw - 32px);
  max-height: calc(100vh - 32px);
  overflow-y: auto;
  overflow-x: hidden;
  border: 1px solid var(--color-border-strong);
  background-color: var(--color-surface);
  border-radius: 12px;
  box-shadow: 0 22px 55px rgba(15, 23, 42, .2);
  background-clip: padding-box;
  animation: .3s ${fadeIn} ease-out;
`



const ModalHeaderContainer = styled.header`
  position: ${({$variant}) => ($variant === "search" ? "sticky" : "relative")};
  top: ${({$variant}) => ($variant === "search" ? "0" : "auto")};
  z-index: ${({$variant}) => ($variant === "search" ? "20" : "auto")};
  padding: ${({$variant}) => ($variant === "search" ? "20px 25px" : "17px 25px")};
  border-bottom: 1px solid ${({$variant}) => ($variant === "search" ? "#e5eaf0" : "#dadada")};
  background: ${({$variant}) => ($variant === "search"
      ? "linear-gradient(135deg, var(--color-surface) 0%, #f6faff 100%)"
      : "var(--color-surface)")};
  border-radius: 12px 12px 0 0;
  color: ${({$variant}) => ($variant === "search" ? "#2f3945" : "inherit")};
  font-size: ${({$variant}) => ($variant === "search" ? "var(--font-size-17)" : "var(--font-size-20)")};
  font-weight: ${({$variant}) => ($variant === "search" ? 750 : 600)};
`

const ModalFooterContainer = styled.footer`
  display: flex;
  justify-content: center;
  padding: 20px;
  border-top: 1px solid #f2f2f2;
  button {
    width: 150px;
    height: 50px;
    margin: 0 5px;
    font-size: var(--font-size-17);
    padding: 0;
  }
`
const LabelInline = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

const Close = styled.div`
  padding: 4px;
  width: 24px;
  height: 24px;
  background-image: url('/assets/images/common/btn_popup_close.png');
  background-repeat: no-repeat;
  background-position: center;
  cursor: pointer;
`
